import React from "react";
import "./Intro.scss";
import imgBg from "../../images/introbackground.png";
import imgBgAvif from "../../images/introbackground.avif";
import imgApp from "../../images/introapp.png";
import imgAppMobile from "../../images/introappmobile.png";
import imgAppMobileAvif from "../../images/introappmobile.avif";
import imgAppAvif from "../../images/introapp.avif";
import imgRussiaflag from "../../images/russiaflag.png";
import { TitleAccent } from "shared/components/TitleAccent";
import backgroundAppAvif from '../../images/backgroundApp.avif'
import { MinDigitsBrand } from "shared/components/MinDigitsBrand";
// import PreloadLinks from "./PreloadLinks";



function Intro() {
  const renderTitle = () => {
    return <div className="page-title mb-4" style={{ fontSize: '50px', fontWeight: 'bold' }}>
      <TitleAccent className='mb-3'>
        SCADA NPT
      </TitleAccent>
      <TitleAccent className='mb-3'>
        Compact
      </TitleAccent>
    </div>
  }
  const renderDecription = () => {
    return <>
      {/* <PreloadLinks /> */}
      <div
        className="page-description"
        style={{ fontSize: "24px", fontWeight: "normal", letterSpacing: "2px" }}
      >
        <div>
          Концептуально <ColorAccent>компактная</ColorAccent>,
        </div>
        <div>
          но <ColorAccent>безграничная</ColorAccent> в возможностях
        </div>
        <div>
          <ColorAccent>автоматизация</ColorAccent>
        </div>
      </div>
    </>

  }

  const renderBrands = () => {

    return (
      <div className="d-flex intro__brands">
        <div
          style={{
            whiteSpace: "nowrap",

            letterSpacing: "1px",
            color: "#00000090",
            marginRight: "2rem",
          }}
          className="d-flex "
        >
          <div style={{ marginRight: ".5rem" }}>
            <div>Сделано в</div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "calc(var(--brands-font-size) * 1.2)",
                lineHeight: "calc(var(--brands-font-size) * 1.2)",
              }}
            >
              России
            </div>
          </div>
          <div>
            <img src={imgRussiaflag} />
          </div>
        </div>
        <MinDigitsBrand id="309051" />

      </div>
    );
  };
  return (
    <section className=" row position-relative intro intro-tab"
      // <section className="intro row position-relative"
      style={{
        marginTop: 0,
        height: '640px',
        background: 'transparent'
      }}>
      <picture  >
        <source srcSet={backgroundAppAvif} media="(max-width: 1000px)" type="image/avif" />
        <source srcSet={imgBgAvif} type="image/avif" />
        <img
          src={imgBg}
          className="position-absolute "
          style={{ width: '100%', objectFit: 'cover', height: '100%', padding: '0' }}
        ></img>
      </picture>
      {/* <picture  >
        <source srcSet={backgroundAppAvif} media="(max-width: 1000px)" type="image/avif" />
        <img
          src={backgroundApp}
          className="position-absolute "
          fetchpriority="high"
          style={{
            width: "100%",
            objectFit: "cover",
            height: "100%",
            padding: "0",

          }}
        ></img>
      </picture> */}

      <Content className="d-flex intro__content">

        <div style={{ zIndex: 1, width: '40%', paddingTop: '2rem', paddingLeft: '0' }} className="d-flex flex-column  h-100 position-relative intro__data">
          {renderTitle()}
          {renderDecription()}
          {renderBrands()}
        </div>
        <div style={{ zIndex: 1, width: '50%' }} className="d-flex align-items-center  h-100 position-relative intro__image">
          <picture>
            <source
              media="(max-width: 740px)"
              srcSet={imgAppMobileAvif} type="image/avif" />
            <source
              media="(max-width: 740px)"
              srcSet={imgAppMobile} />

            <source
              media="(min-width: 741px)"
              srcSet={imgAppAvif}
              type="image/avif" />
            <source
              media="(min-width: 741px)"
              srcSet={imgApp} />

            <img
              src={imgApp}
              alt=""

              loading="eager"
              style={{ width: '170%', padding: '0', top: 0, position: 'absolute' }}
            />
          </picture>
          {/* {!isMobile ? <picture  >
            <source srcSet={imgAppAvif} type="image/avif" />
            <img style={{ width: '170%', padding: '0', top: 0, position: 'absolute' }} src={imgApp} alt="..." />
          </picture> :
            <img style={{ width: '170%', padding: '0', top: 0, position: 'absolute' }} src={imgAppMobile} />
          } */}
        </div>

      </Content>

    </section>
  );
}

const ColorAccent = ({ children }) => {
  return <span style={{ fontWeight: 'bold' }} className="text-danger ">{children}</span>
}

const Content = ({ children, className }) => {
  return (
    <div
      className={className}
      style={{

      }}
    >
      {children}
    </div>
  );
}
export default Intro;

